import * as React from 'react';
import { HashRouter as Router, Switch, Route, Redirect } from 'react-router-dom';
import asyncComponent from '../common/util/asyncComponent.jsx'
import { Provider } from 'react-redux'
import store from "../redux/store"
import 'babel-polyfill'
import '../common/util/detect'
import '../common/constants'
import '../common/util/fetch'
const Market = asyncComponent(() => import("../pages/activity/market/index.tsx"));
const Download = asyncComponent(() => import("../pages/download/index.tsx"));
const Topic = asyncComponent(() => import("../pages/activity/topic/index.tsx"));
const K12 = asyncComponent(() => import("../pages/activity/k12/index.tsx"));
const Live = asyncComponent(() => import("../pages/activity/live/index.tsx"));
const OnlyOne = asyncComponent(() => import("../pages/activity/onlyone/index.tsx"));
const Summer = asyncComponent(() => import("../pages/activity/summer/index.tsx"));
const SummerVacation = asyncComponent(() => import("../pages/activity/summerVacation/index.tsx"));

class InRouter extends React.Component {
    componentDidMount = async () => {

    }
    render() {
        return (
            <Provider store={store}>
                <Router>
                    <Switch>
                        {/*分销专题*/}
                        {/*<Route path="" component={Market} />*/}
                        {/*/!*下载页*!/*/}
                        {/*<Route path="" component={Download}/>*/}
                        {/*/!*老活动*!/*/}
                        {/* <Route path="" component={Topic}/>*/}
                        {/*/!*一元购*!/*/}
                        <Route path="" component={OnlyOne}/>
                        {/*/!*K12*!/*/}
                        {/*<Route path="" component={K12} />*/}
                        {/*/!*直播半屏拉起*!/*/}
                        {/*<Route path="/live" component={Live} />*/}
                        {/*/!*夏季大促*!/*/}
                        {/*<Route path="/summer/pre" component={Summer}/>*/}
                        {/* 下载页 */}
                        {/* <Route path="/download" component={Download}/> */}
                    </Switch>
                </Router>
            </Provider>
        )
    }
}

export default InRouter



// WEBPACK FOOTER //
// ./src/router/router.js